import request, { METHOD, requestSet } from '@/utils/request'

export function apiControlPlanReportList (query) {
  return request({
    url: '/plan/mom/receipt/plan/controlPlanReportList',
    method: 'get',
    params: query
  })
}
export function apiControlPlanReportListSum (query) {
  return request({
    url: '/plan/mom/receipt/plan/controlPlanReportListSum',
    method: 'get',
    params: query
  })
}
// 导出总控计划报表
export function apiExportControlPlanReportList (query) {
  return request({
    url: '/plan/mom/receipt/plan/exportControlPlanReportList',
    method: 'get',
    params: query
  })
}
// 导出入库执行报表
export function apiExportInventoryExecutionReportList (query) {
  return request({
    url: '/plan/mom/receipt/plan/exportInventoryExecutionReportList',
    method: 'get',
    params: query
  })
}
// 入库执行报表
export function apiInventoryExecutionReportList (query) {
  return request({
    url: '/plan/mom/receipt/plan/inventoryExecutionReportList',
    method: 'get',
    params: query
  })
}
// 提交
export function apiPlanSubmit (param) {
  return requestSet(`/plan/mom/receipt/plan/submit`, METHOD.POST, param)
}

// 同步SCM入库计划
export function apiSynReceiptPlanFromScm (param) {
  return requestSet(`/plan/mom/receipt/plan/synReceiptPlanFromScm`, METHOD.POST, param)
}
